import { TranslateService } from '@ngx-translate/core';
import { Notification, NotificationData } from './notification.model';

export class ConsentFormNotification extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    const haveResponse: boolean | string | null = data.consentForm ? data.consentForm.signed : this.readDate;
    this.description = this.translateService.instant('consent_form_from_doctor', { doctor: data?.consentForm?.doctor });
    this.actionName = !!haveResponse ? this.translateService.instant('completed') : this.translateService.instant('to_complete');
    this.actionRequired = !this.readDate;
  }
}
